export enum CustomerSalesProductStatus {
  Active = "A",
  Inactive = "I",
  HoldDuePaymentIssue = "H",
  Cancelled = "L",
}
